import { AxiosResponse } from "axios";
import { ApiResponse } from "../models/IPages";
import $api from "../http";

export default class RoleService {
  
  static async fetchUser(): Promise<AxiosResponse<ApiResponse>> {
    return await $api.get<ApiResponse>("/user/getUser");
  }

  static async registerUser(data: any): Promise<AxiosResponse<ApiResponse>> {
    return await $api.post<ApiResponse>("/user/register", data);
  }

  static async deleteAdmin(id: any): Promise<AxiosResponse<ApiResponse>> {
    return await $api.delete<ApiResponse>(`/user/adminDelete/${id}`);
  }

  static async updateAdmin(id: string, data: any): Promise<AxiosResponse<ApiResponse>> {
    return await $api.put<ApiResponse>(`/user/adminUpdate/${id}`, data);
  }

  static async fetchSingleUser(id:any): Promise<AxiosResponse<ApiResponse>> {
    return await $api.get<ApiResponse>(`/user/getSingleUser/${id}`);
  }

  static async updatePassword(id:string, data:Object): Promise<AxiosResponse<ApiResponse>> {
    return await $api.patch<ApiResponse>(`/user/updateUserPassword/${id}`, data);
  }

  static async updateStatus(id:string, data:Object): Promise<AxiosResponse<ApiResponse>> {
    return await $api.patch<ApiResponse>(`/user/updateUserStatus/${id}`, data);
  }

}